import { uuid } from './regex';

export const CRMRoutes = {
    path: 'crm',
    conversations: {
        path: 'conversations',
        details: {
            path: `:conversationId(${uuid})`,
        },
    },
    listings: {
        path: 'listings',
    },
    tasks: {
        path: 'tasks',
    },
    integrations: {
        path: 'integrations',
    },
};
